import React from 'react'
import Typography from 'britive-design-system/core/components/typography'

const PERMISSION_DETAILS = 'constraint-drawer-permission-details'

const ConstraintPermissionDetails = ({
  permissionName,
  permissionDescription,
  permissionType,
}) => {
  return (
    <div className={`${PERMISSION_DETAILS}`}>
      <div>
        <Typography variant="label2"> Name </Typography>
        <div className={`${PERMISSION_DETAILS}-label`}>
          <Typography variant="label1">{permissionName || 'None'}</Typography>
        </div>
      </div>
      <div className={`${PERMISSION_DETAILS}-description`}>
        <Typography variant="label2"> Description </Typography>
        <div className={`${PERMISSION_DETAILS}-label`}>
          <Typography variant="label1">{permissionDescription || 'None'}</Typography>
        </div>
      </div>
      <div>
        <Typography variant="label2"> Permission Type </Typography>
        <div className={`${PERMISSION_DETAILS}-label`}>
          <Typography variant="label1">{permissionType || 'None'}</Typography>
        </div>
      </div>
    </div>
  )
}

export default ConstraintPermissionDetails
